export default [
  {
    path: 'elective',
    name: 'courseList',
    component: () => import('@/views/learning/elective/Index.vue'),
  },
];
